var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3556 6.62364L22.3378 6.59294C22.3132 6.54189 22.2848 6.493 22.2531 6.44654L18.9143 0.674064C18.6738 0.258282 18.226 0 17.7457 0H6.25486C5.77378 0 5.32566 0.258891 5.08523 0.675798L1.69195 6.56265C1.66138 6.61572 1.63935 6.67122 1.62379 6.72761C1.57602 6.85656 1.54977 6.99592 1.54977 7.14133V22.346C1.54977 23.258 2.29176 24 3.20376 24H20.7962C21.7082 24 22.4502 23.258 22.4502 22.346V7.08559C22.4502 7.0652 22.4495 7.04495 22.4485 7.0248C22.458 6.88947 22.4287 6.74992 22.3556 6.62364ZM12.7274 1.40677H17.713L20.3395 5.9477H12.7274V1.40677ZM6.28763 1.40677H11.3207V5.9477H3.67012L6.28763 1.40677ZM21.0434 22.346C21.0434 22.4823 20.9325 22.5932 20.7962 22.5932H3.20376C3.06745 22.5932 2.95654 22.4823 2.95654 22.346V7.35447H21.0434V22.346Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1929 12.6575C14.9183 12.3829 14.4729 12.3829 14.1982 12.6575L11.0575 15.7982L9.84977 14.5905C9.57513 14.3159 9.12972 14.3159 8.85503 14.5905C8.58035 14.8652 8.58035 15.3106 8.85503 15.5853L10.5602 17.2903C10.6975 17.4276 10.8776 17.4964 11.0575 17.4964C11.2375 17.4964 11.4176 17.4276 11.5549 17.2903L15.1929 13.6522C15.4676 13.3775 15.4676 12.9322 15.1929 12.6575Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.4aef0b795ff340b15a9e5ade6e008f70.svg";
export { ForwardRef as ReactComponent };